import { Button } from '@chakra-ui/react';
import { NoticePanel } from '@fluenceur/ui';
import type { PlanTier } from '@fluenceur/types';
import { PauseSolid } from 'iconoir-react';
import { usePlanLimitOffer } from './use-plan-limit-offer';

/**
 * What a brand that moved down a plan keeps but cannot run (its Flows, its
 * connected assistants): kept as they are, suspended until it moves back to
 * the plan that includes them. The page under it stays readable; the banner
 * only says why nothing runs and offers the way back.
 */
export const PlanSuspendedBanner = ({
  title,
  body,
  currentTier,
  targetTier,
}: {
  title: string;
  body: string;
  currentTier: PlanTier;
  targetTier: PlanTier;
}) => {
  const offer = usePlanLimitOffer(currentTier, targetTier, () => undefined);

  return (
    <NoticePanel
      tone="warning"
      icon={<PauseSolid width={18} height={18} />}
      title={title}
      actions={
        offer.upgradeLabel ? (
          <Button size="sm" colorPalette="gray" loading={offer.isUpgrading} onClick={offer.upgrade}>
            {offer.upgradeLabel}
          </Button>
        ) : null
      }
    >
      {body}
    </NoticePanel>
  );
};
